import { UploadMeta, UploadResponse } from "../types/common";

import request from "./common";

export type DownloadMeta = {
    developerAccountName?: string;
    contractorAccountName?: string;
};

const attachmentApi = {
    upload: async (data: File, meta?: UploadMeta): Promise<UploadResponse> => {
        const formData: FormData = new FormData();
        formData.append("file", data);
        if (meta?.contractorAccountName) {
            formData.append("contractorAccountName", meta.contractorAccountName);
        }
        if (meta?.developerAccountName) {
            formData.append("developerAccountName", meta.developerAccountName);
        }

        return request<UploadResponse, FormData>(
            "/attachment/upload",
            "POST",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            },
        );
    },
    remove: (hash: string): Promise<unknown> => {
        return request<unknown>(`/attachment/delete/${hash}`, "DELETE");
    },
    getDownloadPath: (id: string, meta?: DownloadMeta): string => {
        const params = attachmentPartyParams(meta);
        const query = params.length ? `?${params.join("&")}` : "";
        return `/api/v1/attachment/download/${id}${query}`;
    },
};

const attachmentPartyParams = (meta?: DownloadMeta): string[] => {
    const params: string[] = [];
    if (meta?.developerAccountName) {
        params.push(
            `developerAccountName=${encodeURIComponent(meta.developerAccountName)}`,
        );
    }
    if (meta?.contractorAccountName) {
        params.push(
            `contractorAccountName=${encodeURIComponent(meta.contractorAccountName)}`,
        );
    }
    return params;
};

export const getDownloadPathWithToken =
    (token: string) =>
    (id: string, meta?: DownloadMeta): string => {
        const params = [`access-token=${token}`, ...attachmentPartyParams(meta)];
        return `/api/v1/token-access/attachment/download/${id}?${params.join(
            "&",
        )}`;
    };

export type AttachmentApi = typeof attachmentApi;
export default attachmentApi;
